import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchWorkersV2Api, type Worker } from '../../api/workersApi';
import HandlerCatalogMenuPaneV2 from './HandlerCatalogMenuPaneV2';
import HandlerCatalogRegisterPaneV2 from './HandlerCatalogRegisterPaneV2';
import type { CreateHandlerPreset } from './CreateHandlerFormV2';

const WORKERS_QUERY_KEY = ['admin', 'orchestrator', 'workers'] as const;

export default function HandlerCatalogPanelV2() {
  const [preset, setPreset] = React.useState<CreateHandlerPreset | null>(null);
  const [aiOpenRequestId, setAiOpenRequestId] = React.useState(0);

  const workersQuery = useQuery<{ items: Worker[] }, Error>({
    queryKey: [...WORKERS_QUERY_KEY, 'v2'],
    queryFn: async () => {
      const res = await fetchWorkersV2Api({ limit: 500 });
      return { items: res.items ?? [] };
    },
    staleTime: 30_000,
  });

  const workersLoading = workersQuery.isLoading;
  const workersError = workersQuery.error ?? null;
  const workers = React.useMemo(() => {
    const items = (workersQuery.data?.items ?? []).slice();
    items.sort((a, b) => String(a.worker_key ?? '').localeCompare(String(b.worker_key ?? ''), undefined, { sensitivity: 'base' }));
    return items;
  }, [workersQuery.data]);

  return (
    <div className="h-full min-h-0 flex flex-col gap-4">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 flex-1 min-h-0">
        <div className="min-h-0">
          <HandlerCatalogMenuPaneV2
            workers={workers}
            workersLoading={workersLoading}
            workersError={workersError}
            onNew={() => {
              setPreset(null);
              setAiOpenRequestId((v) => v + 1);
            }}
            onNewVersion={(p) => setPreset(p)}
          />
        </div>

        <div className="min-h-0">
          <HandlerCatalogRegisterPaneV2
            workers={workers}
            preset={preset}
            aiOpenRequestId={aiOpenRequestId}
            onCancel={() => setPreset(null)}
            onCreated={() => setPreset(null)}
          />
        </div>
      </div>
    </div>
  );
}
